/*
    Script utilisé pour les galleries d'images
 */
$(function () {

    $('.gallerie').each(function() {
        var $main = $(this).find('.slider-main');
        var $nav = $(this).find('.slider-nav');

        $main.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: true,
            asNavFor: '#' + this.id + ' .slider-nav',
            autoplay: true,
            autoplaySpeed: 5000,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        dots: true
                    }
                }
            ]
        });

        // Sera caché sur mobile
        $nav.slick({
            slidesToShow: 8,
            slidesToScroll: 1,
            asNavFor: '#' + this.id + ' .slider-main',
            arrows: true,
            infinite: false,
            dots: false,
            focusOnSelect: true,
            appendArrows: '#' + this.id + ' .nav-container',
            prevArrow: '<div class="col-arrow"><button type="button" title="Précédent" class="slick-prev"><i class="fa fa-chevron-circle-left" aria-hidden="true"></i></button></div>',
            nextArrow: '<div class="col-arrow"><button type="button" title="Suivant" class="slick-next"><i class="fa fa-chevron-circle-right" aria-hidden="true"></i></button></div>',
            responsive: [
                {
                    breakpoint: 1319,
                    settings: {
                        slidesToShow: 6
                    }
                },
                {
                    breakpoint: 900,
                    settings: {
                        slidesToShow: 5
                    }
                }
            ]
        });
        if ($(this).hasClass('gallerie-with-download-btn')) {

            $('.btn-download', $(this)).off('click').on('click', function () {
                let link = $('.slick-active img').data('large');
                if (link) {
                  let a = $('<a>')
                      .attr('href', link)
                      .attr('download', $('.slick-active img').data('name'))
                      .appendTo('body');

                  a[0].click();

                  a.remove();
                }
            })
        }
    });
    $('.gallerie-with-text-overlay').each(function() {
        var $main = $(this).find('.slider-main');
        var $nav = $(this).find('.slider-nav');

        $main.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: true,
            dots: true,
            autoplay: true,
            autoplaySpeed: 5000,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        dots: true
                    }
                }
            ]
        });


    });
});
